import { InjectionToken } from '@angular/core';
import {
    ProductExtended,
    EpoxyPatterns,
    PagedResponse,
    ProductFilterResponseDto,
} from '@floori/models';
import { Observable } from 'rxjs';

export const FLOORI_EPOXY_PROVIDER = new InjectionToken('FLOORI_EPOXY_PROVIDER');

export interface EpoxyProvider {
    activeEpoxy$: Observable<{
        color: ProductExtended | null;
        chips: ProductExtended[] | null;
        density?: EpoxyPatterns;
    }>;
    currentEpoxyChips$: Observable<PagedResponse<ProductFilterResponseDto> | undefined>;
    currentEpoxyColors$: Observable<PagedResponse<ProductFilterResponseDto> | undefined>;
    epoxyLoaded$: Observable<boolean>;

    fetchEpoxyColors(id: string): void;

    fetchEpoxyChips(id: string): void;

    fetchEpoxy(ids: [string, string]): void;

    setEpoxyColorItems(items: PagedResponse<ProductFilterResponseDto>): void;

    setEpoxyChipsItems(items: PagedResponse<ProductFilterResponseDto>): void;

    setEpoxyProduct(
        product?: ProductExtended,
        isColor?: boolean,
        multipleSelectMode?: boolean,
    ): void;

    setEpoxyLoaded(loaded: boolean): void;

    clearEpoxyColor(product?: ProductExtended | null): void;

    clearEpoxyChip(
        product?: ProductExtended | null,
        clearAllEpoxyChips?: boolean,
        multipleSelectMode?: boolean,
    ): void;

    clearEpoxy(): void;

    updateDensity(density: EpoxyPatterns): void;
}
